import { automaticallyShowInAppMessages, initialize } from '@braze/web-sdk';
import { BRAZE_API_KEY, BRAZE_SDK_ENDPOINT, SAFARI_WEBSITE_PUSH_ID } from 'settings';

initialize(BRAZE_API_KEY, {
  baseUrl: BRAZE_SDK_ENDPOINT,
  safariWebsitePushId: SAFARI_WEBSITE_PUSH_ID,
});

automaticallyShowInAppMessages();
